import { handleAutoSubmitForm } from "javascripts/common/utils"
import { handleCookieConsent } from "javascripts/common/cookie-consent"

document.addEventListener("DOMContentLoaded", () => {
  handleAutoSubmitForm()
  handleCookieConsent(document.querySelector(".cookie-consent"))
})
